import { ItemFilterValue, KnowledgeFilterValue } from '@knowledge/knowledges/spu/FilterBar';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { useCallback } from 'react';
import { get } from 'lodash-es';

interface CacheRef<T> {
  current: T;
}

export const defaultPage = {
  current: 1,
  pageSize: 10,
  total: 0,
};

interface ItemKnowledgeCache {
  filterMode: Knowledge.SPU.queryTypes;
  knowledgeFilterValue: KnowledgeFilterValue;
  itemFilterValue: ItemFilterValue;
  knowledgePage: typeof defaultPage;
  itemPage: typeof defaultPage;
}

const itemKnowledgeCacheRef: CacheRef<ItemKnowledgeCache | undefined> = {
  current: undefined,
};

export const getItemKnowledgeCache = () => itemKnowledgeCacheRef.current;

export const updateItemKnowledgeCache = (cache?: ItemKnowledgeCache) => {
  itemKnowledgeCacheRef.current = cache;
};

export const getSegmentsValue = (
  {
    segments = [],
    segmentsMultiLang,
  }: Pick<Knowledge.SPU.KnowledgeValue, 'segments' | 'segmentsMultiLang'>,
  lang: General.SystemLanguage,
  getFirstValue = false,
) => {
  if (segments.length > 0 && !getFirstValue) {
    return segments;
  }
  try {
    const multilang: Partial<
      Record<'CN' | 'EN' | 'ID' | 'TH' | 'PH' | 'MY' | 'VN' | 'PT', Knowledge.SPU.Segment[]>
    > = JSON.parse(segmentsMultiLang) || {};

    const langMap = {
      'zh-CN': 'CN',
      'en-US': 'EN',
      id: 'ID',
      th: 'TH',
      tl: 'PH',
      vi: 'VN',
      pt: 'PT',
      es: 'EN',
    } as const;

    return (
      multilang[langMap[lang]] ||
      (getFirstValue ? get(Object.values(multilang), 0, []) : multilang.CN) ||
      []
    );
  } catch (err) {
    return [];
  }
};

// 在高风险场景的时候，不根据语言，无脑取第一个值展示
export const useGetSegmentsValue = (getFirstValue = false) => {
  const lang = useSystemLanguageValue();

  return {
    lang,
    getSegmentsValue: useCallback(
      (parameter: Parameters<typeof getSegmentsValue>[0]) =>
        getSegmentsValue(parameter, lang, getFirstValue),
      [lang, getFirstValue],
    ),
  };
};
